import { render, staticRenderFns } from "./PlatformInvoiceTab.vue?vue&type=template&id=03342cba&scoped=true"
import script from "./PlatformInvoiceTab.vue?vue&type=script&lang=js"
export * from "./PlatformInvoiceTab.vue?vue&type=script&lang=js"
import style0 from "./PlatformInvoiceTab.vue?vue&type=style&index=0&id=03342cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03342cba",
  null
  
)

export default component.exports